import { useState, useEffect } from 'react';
import moment from 'moment';
import { getStudioCalendarData } from '@sg/services/index';
import { defaultQS } from '../../config';

/**
 * Hook to manage Timeline (Pipeline Calendar) data
 * Fetches and transforms studio calendar data for the timeline visualization
 */
export const usePipelineCalendarData = (selectedMonth?: string | null) => {
  const [qAllData, setqAllData] = useState(defaultQS);

  /**
   * Fetch calendar data for all quarters
   * Transforms the API response to match the expected format for TimeLine component
   */
  const getAllYearData = async () => {
    // Calculate start_date and end_date based on selectedMonth
    const currentYear = moment().year();
    let startDate = `${currentYear}0101`;
    let endDate = `${currentYear}1231`;
    
    if (selectedMonth) {
      const year = moment(selectedMonth, 'YYYY-MM').year();
      startDate = `${year}0101`;
      endDate = `${year}1231`;
    }

    try {
      const res = await getStudioCalendarData({
        type: 2,
        granularity: 2,
        start_date: startDate,
        end_date: endDate,
        pteam: [],
        business_owner: [],
        platform: [],
        milestone: [],
        publisher: [],
        status: [],
        stage: [
          'Live',
          'Development',
          'Legacy',
          'Pre-planned',
          'Planned'
        ],
        form: [],
        studios: [],
        projects: []
      });

      // Map API response data to each quarter in qAllData
      const tdata = qAllData.map((item: any, index) => ({
        ...item,
        data: res?.data?.[index]?.list || []
      }));

      setqAllData(tdata);
    } catch (error) {
      console.error('Failed to fetch timeline data:', error);
    }
  };

  // Fetch timeline data on mount and when selectedMonth changes
  useEffect(() => {
    getAllYearData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMonth]);

  return {
    qAllData,
    getAllYearData, // Expose for manual refresh if needed
  };
};
